import scheduleActionRequested from '../actions/scheduleActionRequested';
import processingEnded from '../actions/processingEnded';
import { CALC_ENGINE_ACTION_PREFIX } from '../utilities/constants';

const isCalcEngineRelatedAction = (action) =>
  action.type.startsWith(CALC_ENGINE_ACTION_PREFIX) &&
  action.type !== processingEnded.type;

const processingMiddleware = (store) => (next) => (action) => {
  next(action);

  if (isCalcEngineRelatedAction(action)) {
    store.dispatch(scheduleActionRequested(processingEnded()));
  }
};

export default processingMiddleware;
